<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-产品-修改
    -->
    <el-dialog
    title="修改产品"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="产品名称" prop="name"><el-input v-model="form.name" placeholder="请输入产品名称" class="max-w460"></el-input></el-form-item>
    

      <el-form-item label="所属分类：" prop="model.category_id">
      <el-select v-model="form.category_id">
        <template v-for="cat in catgory">
          <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>


    <el-form-item label="产品图片：" prop="model.image">
    <div class="draggable-list">

          <div >
            <div class="item">
              <img v-img-url="form.image" alt="file_path"/>
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(0,'album')"><i class="el-icon-close"></i></a>
        
                      </div>
          </div>

      <div class="item img-select" @click="openProductUpload('album')">
        <i class="el-icon-plus"></i>
      </div>
    </div>
  </el-form-item>

    <el-form-item label="产品bannar：" prop="model.image">
    <div class="draggable-list">
      <draggable class="wrapper" v-model="form.bannar">
        <transition-group>
          <div v-for="(item, index) in form.bannar" :key="item.file_path">
            <div class="item">
              <img v-img-url="item.file_path" alt="file_path"/>
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
            </div>
          </div>
        </transition-group>
      </draggable>
      <div class="item img-select" @click="openProductUpload('bannar')">
        <i class="el-icon-plus"></i>
      </div>
    </div>
  </el-form-item>


  <el-form-item label="产品价格" prop="price">
    <el-input v-model="form.price" type="number" placeholder="请输入产品价格" class="max-w460"></el-input></el-form-item>
  

    <el-form-item label="产品提示" prop="tip">
      <el-input v-model="form.tip" type="textarea" placeholder="请输入产品提示" class="max-w460"></el-input>
    </el-form-item>
  
    <el-form-item label="虚拟浏览量" prop="fview">
    <el-input v-model="form.fview" type="number" placeholder="请输入虚拟浏览量" class="max-w460"></el-input></el-form-item>
    <!-- 2024年12月新增 -->
    <el-form-item label="产品类型" prop="productType">
    <el-switch  v-model="form.productType" active-text="定制" inactive-text="标品">
    </el-switch>
    </el-form-item>
      
    
         <!-- 选择标签 -->
  <el-form-item label="选择子类型" >
      <el-select id="searchType" @change="typeChange" class="searchType">
        <el-option v-for="(item,index) in type" :key="index" :label="item.name" :value="item"></el-option>
              
      </el-select>
    </el-form-item>


    <el-form-item label="类型" >

      <el-table :data="form.hproducttosubcategories"  border size="mini" style="width: 100%;margin-top: 20px;">

        <el-table-column prop="name" label="排序"  >
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input style="width: 150px;"  v-model="scope.row.sort"  placeholder="请输入排序"></el-input>
              </div>
            </template>
          </el-table-column>


          <el-table-column prop="name" label="类型"   width="100" >
            <template v-slot="scope">
              <div class="d-s-c">
                {{ scope.row.name }}
              </div>
            </template>
          </el-table-column>     

          <el-table-column prop="name" label="价格" width="100">
                <template v-slot="scope">
                    <div class="d-s-c">
                       <el-input v-model="scope.row.price"></el-input>

                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="name" label="最大宽度" width="100">
                <template v-slot="scope">
                    <div class="d-s-c">
                      <el-input v-model="scope.row.max_width" placeholder="cm"></el-input>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="name" label="最大高度" width="100">
                <template v-slot="scope">
                    <div class="d-s-c">
                      <el-input v-model="scope.row.max_height" placeholder="cm"></el-input>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="name" label="最大厚度" width="100">
                <template v-slot="scope">
                    <div class="d-s-c">
                      <el-input v-model="scope.row.max_thickness" placeholder="cm"></el-input>
                    </div>
                </template>
            </el-table-column>

          <el-table-column prop="name" label="操作"  width="100">
            <template v-slot="scope">
              <div style="color: blue;" @click="delType(scope.$index)">删除</div>

            </template>
          </el-table-column>
        </el-table>
    </el-form-item>  
    <!-- 参数选择 -->
    <el-form-item label="选择参数">
          <el-select 
          v-model="form.selectedParam" 
          @change="parameterChange"
          placeholder="请选择参数"
          clearable
          filterable
          style="width: 100%"
          >
          <el-option-group
            v-for="parent in parameterList"
            :key="parent.id"
            :label="parent.name"
          >
            <el-option
                v-for="child in parent.child"
                :key="child.id"
                :label="child.name"
                :value="child"
            />
          </el-option-group>
          </el-select>

    </el-form-item>
    <el-form-item label="参数">
        <el-table :data="form.hproducttoattrs" 
        row-key="category_id"
        border size="mini" style="width: 100%;margin-top: 20px;">
            
        
        
        <el-table-column prop="name" label="排序">
                <template v-slot="scope">
                    <div class="d-s-c">
                        <el-input style="width: 100px;" v-model="scope.row.sort"
                            placeholder="请输入排序"></el-input>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" width="200">
                <template v-slot="scope">
                    <div class="d-s-c">
                        {{ scope.row.name }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="name" label="价格" width="200">
                <template v-slot="scope">
                    <div class="d-s-c">
                      <el-input v-model="scope.row.price"></el-input>
                    </div>
                </template>
            </el-table-column>

   
            <el-table-column prop="name" label="操作" width="100">
                <template v-slot="scope">
                    <div style="color: blue;cursor: pointer;" @click="delPara(scope.$index)">删除</div>
                </template>
            </el-table-column>
        </el-table>
    </el-form-item>
      <!-- 供应商选择 -->
      <el-form-item label="选择供应商" v-if="!issupply" >
        <el-select @change="storeChange" class="max-w460">
            <el-option v-for="(item,index) in supply" :key="item.supply_id" :label="item.name" v-if="item.supply_id!=0"
                :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供应商" v-if="!issupply">

<el-table :data="form.supplyArray"  border size="mini" style="width: 100%;margin-top: 20px;">

<el-table-column prop="name" label="排序"  >
    <template v-slot="scope">
        <div class="d-s-c">
        <el-input style="width: 150px;"  v-model="scope.row.sort"  placeholder="请输入排序"></el-input>
        </div>
    </template>
    </el-table-column>


    <el-table-column prop="name" label="供应商"   width="100">
    <template v-slot="scope">
        <div class="d-s-c">
        {{ scope.row.name }}
        </div>
    </template>
    </el-table-column>     



    <el-table-column prop="name" label="价格" width="100">
        <template v-slot="scope">
            <div class="d-s-c">
                <el-input v-model="scope.row.price"></el-input>

            </div>
        </template>
    </el-table-column>

    <el-table-column prop="name" label="操作"  width="100">
    <template v-slot="scope">
        <div style="color: blue;" @click="delStore(scope.$index)">删除</div>

    </template>
    </el-table-column>
</el-table>
</el-form-item>
    <!-- <el-form-item label="分销价格设置：">
      <el-radio-group v-model="form.distribution_commission_type">
        <el-radio :label="1">单独设置折扣(百分比)</el-radio>
        <el-radio :label="2">单独设置折扣(固定金额)</el-radio>
      </el-radio-group>
      <div v-if="form.distribution_commission_type==1" class="max-w460">
        <el-table
          :data="form.gradeList"
          border
          size="mini"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="会员等级">
          </el-table-column>
          <el-table-column
            prop="name"
            label="折扣">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.product_equity" type="number" placeholder="请输入折扣"></el-input>
                <span class="ml10">%</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="form.distribution_commission_type==2" class="max-w460">
        <el-table
          :data="form.gradeList"
          border
          size="mini"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="会员等级">
          </el-table-column>
          <el-table-column
            prop="name"
            label="金额">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.product_fixed" type="number" placeholder="请输入金额"></el-input>
                <span class="ml10">元</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item> -->

    <el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
     
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import HproductApi from '@/api/hproduct.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import StatisticsApi from '@/api/statistics.js';
import { isNumber } from 'lodash';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
          supply:[],
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
          category_id: 0,
          name: "",
          image: [],
          bannar: [],
          price: 0,
          type: [],
          tip: "",
          fview: 0,
          parameters:[],
          limitedSize:"",
          model:{
              grade_model:1,
              is_alone_grade:1,
              
          },
          productType:false,
          gradeList:[
              {
                  name:"等级1",
                  product_fixed:0,
                  product_equity:0
              },
              {
                  name:"等级2",
                  product_fixed:0,
                  product_equity:0
              },
              {
                  name:"等级3",
                  product_fixed:0,
                  product_equity:0
              }
          ],
          supply_id:[],
          supplyArray:[],
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
      },
      issupply:false,
      supplyInfo:null,
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album",
         type:[],
         parameterList:[],
         catgory:[]
    };
  },
  created() {
    let supply = sessionStorage.getItem("supply")?JSON.parse(sessionStorage.getItem("supply")):null;
    console.log(supply);
    if(supply&&supply.supply_id){
      this.issupply = true;
      this.supplyInfo = supply;
    }
    console.log(this.issupply);
    this.dialogVisible = this.open_add;
    this.getDetail();
    this.getSetting();
    this.getData();
    this.getSupplys();
  },
  props: ["open_add","hproduct_id"],
  methods: {
      getSupplys(){
          let self = this;
          StatisticsApi.getSupply({}, true)
              .then(data => {
            
              self.supply = data.data
          
              })
              .catch(error => {
              });
      },
     // 选择一级参数
     parameterChange(e){
         let that = this 
         let par = e
         var ind = 0;
         that.form.hproducttoattrs.forEach((v,i) => {
                 if(v.category_id == e.category_id){
                     ind++;
                 }
             })
         if(ind <= 0){
          that.form.hproducttoattrs.push(e)
         }
     },
     //  选择供应商
     storeChange(e){
        console.log("dsdas");
        console.log(e);
        if(this.form.supply_id&&this.form.supply_id.length>0){
          let index = this.form.supply_id.findIndex((item)=>item==e.supply_id);
            if (index == -1) {
                this.form.supply_id.push(e.supply_id);
            }
        }else{
          this.form.supply_id = [];
          this.form.supply_id.push(e.supply_id);
        }
        if(this.form.supplyArray&&this.form.supplyArray.length>0){
          let index = this.form.supplyArray.findIndex((item)=>item.supply_id==e.supply_id);
            if (index == -1) {
                this.form.supplyArray.push({sort:e.sort,price:this.form.price,name:e.name,supply_id:e.supply_id});
            }
        }else{
          this.form.supplyArray = [];
          this.form.supplyArray.push({sort:e.sort,price:this.form.price,name:e.name,supply_id:e.supply_id});
        }
        
        console.log(this.form.supplyArray);
    },
    delStore(index) {
        this.form.supplyArray.splice(index, 1);
        this.form.supply_id.splice(index, 1);
    },

     // 删除参数
     delPara(index){
         let that = this 
         that.form.hproducttoattrs.splice(index,1)
         console.log(index)
     },
     
     // 获取参数列表
     getData() {
         let self = this;
         HproductApi.attrList({
                 supply_id: " "
             }, true)
             .then(data => {
                 console.log("data", data.data.list)
                 if(data.code == 1){
                     self.parameterList = data.data.list
                 }
                 // self.loading = false;
                 // self.tableData = data.data.list;
                 // self.categoryModel.catList = self.tableData;
             })
             .catch(error => {
                 self.loading = false;
             });
     },
    getSetting(){
      var self = this;
      self.getSetting_common({
        "item":'hproduct',
        "condi":['catgory','hproduct_subcategory']
      },function(data){
          self.type = data.obj.hproduct_subcategory
          self.catgory = data.obj.catgory;
      })
    },
    delType(index){
        this.form.hproducttosubcategories.splice(index,1)
    },

      typeChange(e){
        console.log('hproduct_subcategory_id',e.hproduct_subcategory_id);
        var ind = 0;
        for(var i=0;i<this.form.hproducttosubcategories.length;i++){
          if(this.form.hproducttosubcategories[i].hproduct_subcategory_id == e.hproduct_subcategory_id){
            ind++;
          }
        }
        if(ind<=0){
          this.form.hproducttosubcategories.push(e);
        }
      
      },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      HproductApi.detail({hproduct_id: self.hproduct_id},true).then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          self.isImg = true
          self.loading = false;
          if(isNumber(res.data.supply_id)){
            self.form.supply_id = [res.data.supply_id] ;
          }else if(res.data.supply_id=="0"){
            self.form.supply_id = [];
          }else{
            self.form.supply_id = res.data.supply_id;
          }
          if(self.issupply){
            let obj = self.form.supplyArray.find(it=>it.supply_id == self.supplyInfo.supply_id);
            self.form.price = obj.price;
          }
          console.log(self.form);
          
          if(!self.form.bannar){
            self.form.bannar = [];
          }
          if(!self.form.image){
            self.form.image = [];
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      form.hproduct_id = self.hproduct_id;
      form.supply_id = JSON.stringify(form.supply_id);
      let supply = sessionStorage.getItem("supply")?JSON.parse(sessionStorage.getItem("supply")):null;
      if(!!this.issupply){
        form.status = 1;
        form.supplyArray.find((it)=>{
          if(it.supply_id == self.supplyInfo.supply_id){
            it.price = self.form.price;
          }
        });
      }
      form.supplyArray = JSON.stringify(form.supplyArray);
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          HproductApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        console.log('e',e);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image = e[0].file_path;
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/supply/product/part/edit.vue